/**
 * Qual dos dois miolos está desenhando — Finanças ou Manutenções.
 *
 * Papel: o tipo do tema, a classe CSS de cada um e o contexto que o
 * `QuadroEmbutido` preenche para os componentes de dentro.
 *
 * Como usar: os primitivos do `components/kit/` de cada módulo leem o tema por
 * `useTemaEmbutido` quando precisam pôr a classe num elemento que nasce fora do
 * quadro — a caixa de diálogo do Radix, que é montada num portal no fim do
 * `<body>`. Sem a classe ali, a caixa sai com os valores do `:root` e não com
 * os do tema: borda bege numa caixa de Manutenções, por exemplo.
 */
import { createContext, useContext } from 'react';

/** Os dois miolos da origem. */
export type TemaEmbutido = 'financeiro' | 'manutencoes';

/** A classe do `index.css` que redefine os tokens `emb-` de cada tema. */
export const CLASSE_DO_TEMA: Readonly<Record<TemaEmbutido, string>> = {
  financeiro: 'tema-financeiro',
  manutencoes: 'tema-manutencoes',
};

/** Preenchido pelo `QuadroEmbutido`; `null` fora dele. */
export const ContextoDoTema = createContext<TemaEmbutido | null>(null);

/**
 * O tema do quadro em volta.
 *
 * @returns O tema; lança fora de um `QuadroEmbutido`, porque um primitivo do kit
 *   sem tema desenharia com os valores errados sem aviso nenhum.
 */
export function useTemaEmbutido(): TemaEmbutido {
  const tema = useContext(ContextoDoTema);
  if (tema === null)
    throw new Error('useTemaEmbutido precisa estar dentro de um QuadroEmbutido.');
  return tema;
}
